import {
  GlobalMessageActionTypes,
  GlobalMessageAction
} from '../globalMessageActionTypes';

export type GlobalMessageSate = {
  globalMessageIsOpen: boolean,
  message: GlobalMessage
}

const defaultState: GlobalMessageSate = {
  globalMessageIsOpen: false,
  message: '',
};

const globalMessage = (
  state: GlobalMessageSate = defaultState,
  action: GlobalMessageAction
): GlobalMessageSate => {
  switch (action.type) {
    case GlobalMessageActionTypes.SHOW_GLOBAL_MESSAGE:
      return {...state, globalMessageIsOpen: true, message: action.payload};

    case GlobalMessageActionTypes.HIDE_GLOBAL_MESSAGE:
      return {...state, globalMessageIsOpen: false, message: ''};

    default:
      return state;
  }
};

export default globalMessage;
